module.exports = __webpack_public_path__ + "static/img/7.5711fb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/zh/7.png
// module id = NdI7
// module chunks = 0